export default __webpack_public_path__ + "notification.2cfb65add84b39e6.svg";